import React from "react";

export function BrandMark({ className = "h-7 w-auto" }) {
  return (
    <img
      data-testid="brand-logo"
      src="/branding/logo-kurdynowski.gif"
      alt="Kurdynowski"
      className={className}
    />
  );
}
